import createModel, { prop } from './lib/create_model';

const FbPage = createModel({
  modelName: 'FbPage',
  properties: {
    id: prop(String).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default FbPage;
